import { Component, Input, OnInit, inject } from '@angular/core';
import { WorkflowUtilService, ITaskListPreview } from '@lib/workflow-integration';
import { PurchaseRequisitionWorkflowDataService } from '../../demand/service/purchase-requisition-workflow-data.service';
import { EprocUser, UserService } from '@lib/user';
import { View } from '@lib/core';

@Component({
    selector: 'purchase-requisition-task-hint',
    templateUrl: './purchase-requisition-task-hint.component.html',
    styleUrls: ['./purchase-requisition-task-hint.component.scss'],
    standalone: false
})
export class PurchaseRequisitionTaskHintComponent implements OnInit {
    private readonly taskDataService = inject(PurchaseRequisitionWorkflowDataService);
    private readonly taskUtil = inject(WorkflowUtilService);
    private readonly userService = inject(UserService);

    @Input() public demandId!: string;

    public task?: ITaskListPreview;
    public user?: EprocUser;

    public navigate(): void {
        if (this.task) {
            this.taskUtil.routeToForm(this.task, View.CLIENT);
        }
    }

    public isCurrentUserAssignee(): boolean {
        return !!this.task?.assignee && this.task?.assignee.id === this.user?.id;
    }

    private getData(): void {
        if (this.demandId) {
            this.taskDataService.getAllTasksForDemand(this.demandId).subscribe((tasks: ITaskListPreview[]) => {
                if (tasks.length > 0) {
                    this.task = tasks[0];
                }
            });
        }
    }

    private async getUser(): Promise<void> {
        this.user = await this.userService.getMyself();
    }

    ngOnInit(): void {
        this.getData();
        this.getUser();
    }
}
